import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { selectHasClientEditAdminOnly, selectIsDataFromTriumph, selectHasClientDirectAccess } from 'src/store/selectors';
import { progressSelectorFactory } from '../../../../common';
import { RootState } from '../../../../reducers';
import { selectAfslId, selectPortfoliosWithoutAll } from '../common/store/selectors';
import { ReportsComponent } from './components/ReportsComponent';
import { selectclientFinancialYears, selectParameters, selectReportGeneration, selectSavedParametersList } from './store/selectors';
import {
  ClientReportsActionTypes,
  fetchClientAccount,
  downloadReport,
  fetchReportParametersList,
  getCGTRecordsForClient,
  getReportParametersById,
  initiateReportGeneration,
  saveAppendixFile,
  saveCoverPageFile,
} from './store/thunks';
import { newReportsSlice } from './store/slice';
import { fetchBenchmarks } from '../performance/store/thunks';
import { selectBenchmarks } from '../performance/store/selectors';

export const ReportActionTypes = [
  ClientReportsActionTypes.DownloadReport,
  ClientReportsActionTypes.FetchClientAccount,
  ClientReportsActionTypes.InitiateReportGeneration,
];

export const ReportParametersActionTypes = [ClientReportsActionTypes.GetReportParametersList, ClientReportsActionTypes.GetReportParametersById];

export const ReportSaveFileActionTypes = [ClientReportsActionTypes.SaveCoverPageFile, ClientReportsActionTypes.SaveAppendixFile];

export const reportsMapStateToProps = (state: RootState) => ({
  parameters: selectParameters(state),
  clientPortfolios: selectPortfoliosWithoutAll(state),
  generateProgress: progressSelectorFactory(ReportActionTypes)(state),
  generateProgressReportParameters: progressSelectorFactory(ReportParametersActionTypes)(state),
  saveFileProgress: progressSelectorFactory(ReportSaveFileActionTypes)(state),
  reportGeneration: selectReportGeneration(state),
  afslId: selectAfslId(state),
  savedParametersList: selectSavedParametersList(state),
  cgtRecords: selectclientFinancialYears(state),
  hasClientEditAdminOnlyPermission: selectHasClientEditAdminOnly(state),
  hasClientDirectAccess: selectHasClientDirectAccess(state),
  isDataFromTriumph: selectIsDataFromTriumph(state),
  benchmarks: selectBenchmarks(state),
  getReportParametersByIdProgress: progressSelectorFactory([ClientReportsActionTypes.GetReportParametersById])(state),
});

export const reportsMapDispatchToProps = {
  ...newReportsSlice.actions,
  downloadReport,
  fetchClientAccount,
  initiateReportGeneration,
  fetchReportParametersList,
  getReportParametersById,
  getCGTRecordsForClient,
  fetchBenchmarks,
  saveCoverPageFile,
  saveAppendixFile,
};

interface MatchParams {
  id?: string;
}

const connector = connect(reportsMapStateToProps, reportsMapDispatchToProps);
export type Props = ConnectedProps<typeof connector> & RouteComponentProps<MatchParams>;
export const ReportsV2Container = connect(reportsMapStateToProps, reportsMapDispatchToProps)(ReportsComponent);
